var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sport1EventListeners = require("@sport1/sport1-event-listeners");

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../../elements/Basic");

var _CardContainer = _interopRequireDefault(require("./CardContainer"));

var _TipModule = _interopRequireDefault(require("./TipModule"));

var _Logos = require("../../Basic/Logos");

var _PropsHelper = require("../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Betting/Voting/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var VOTE_MODULE_STATE_OPEN = 'OPEN';
var VOTE_MODULE_STATE_CLOSED = 'CLOSED';

var getVoteModuleState = function getVoteModuleState(value) {
  var val = value || '';

  switch (val.toUpperCase()) {
    case VOTE_MODULE_STATE_OPEN:
      return VOTE_MODULE_STATE_OPEN;

    default:
      return VOTE_MODULE_STATE_CLOSED;
  }
};

var VoteModule = function (_React$Component) {
  (0, _inherits2.default)(VoteModule, _React$Component);

  var _super = _createSuper(VoteModule);

  function VoteModule(props) {
    var _this;

    (0, _classCallCheck2.default)(this, VoteModule);
    _this = _super.call(this, props);

    _this.componentDidMount = function () {
      var trackData = {
        type: 'BET_FANVOTING_INITIAL',
        competition: _this.props.competition,
        fanvotingType: _this.props.type
      };

      if (_this.props.pageId) {
        _this.listener = _sport1EventListeners.EventRegister.addEventListener("reloadBettingViews_" + _this.props.pageId, function () {
          _sport1EventListeners.EventRegister.emit('trackBettingView', trackData);
        });
      }

      if (typeof _this.props.trackBwin === 'function') {
        _this.props.trackBwin(trackData);
      }
    };

    _this.componentWillUnmount = function () {
      _sport1EventListeners.EventRegister.removeEventListener(_this.listener);
    };

    _this.state = {
      userChoice: props.userChoice === undefined ? -1 : props.userChoice
    };
    return _this;
  }

  (0, _createClass2.default)(VoteModule, [{
    key: "voteForOption",
    value: function voteForOption(id, optionsId, index) {
      this.setState({
        userChoice: index
      });
      this.props.onPressOption(id, optionsId, index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          type = _this$props.type,
          competition = _this$props.competition,
          providerLogo = _this$props.providerLogo,
          _this$props$providerL = _this$props.providerLogoStyles,
          providerLogoStyles = _this$props$providerL === void 0 ? {} : _this$props$providerL,
          buttonStyles = _this$props.buttonStyles,
          cardShadow = _this$props.cardShadow,
          trackBwin = _this$props.trackBwin,
          onOutboundLinkClick = _this$props.onOutboundLinkClick,
          onPressOption = _this$props.onPressOption,
          useFontelloIcons = _this$props.useFontelloIcons,
          highlightColor = _this$props.highlightColor,
          minWidth = _this$props.minWidth,
          iconSize = _this$props.iconSize,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["id", "type", "competition", "providerLogo", "providerLogoStyles", "buttonStyles", "cardShadow", "trackBwin", "onOutboundLinkClick", "onPressOption", "useFontelloIcons", "highlightColor", "minWidth", "iconSize"]);
      var _this$props$voting = this.props.voting,
          title = _this$props$voting.title,
          options = _this$props$voting.options,
          betting = _this$props$voting.betting;
      if (!type || !options) return null;
      var logoWidth = providerLogoStyles.width,
          logoHeight = providerLogoStyles.height,
          logoContainerStyles = providerLogoStyles.containerStyles;
      var userChoice = this.state.userChoice;
      var votedOptionId = (0, _PropsHelper.getValueConditionally)(userChoice >= 0, id + "_" + userChoice);
      var hasBeenVoted = votedOptionId !== undefined;
      var bettingOption = (0, _PropsHelper.getValueConditionally)(hasBeenVoted && betting.options, (0, _get.default)(betting, "options[" + userChoice + "]"));
      var state = getVoteModuleState(this.props.voting.state);
      return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
        isFlex: true,
        pb: 3
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124,
          columnNumber: 13
        }
      }), title ? _react.default.createElement(_Basic.Text, {
        center: true,
        bold: true,
        size: "large",
        my: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126,
          columnNumber: 21
        }
      }, title) : null, _react.default.createElement(_Basic.Row, {
        isFlex: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 130,
          columnNumber: 17
        }
      }, options.map(function (option, index) {
        var optionsId = id + "_" + index;
        return _react.default.createElement(_CardContainer.default, {
          key: optionsId,
          type: type,
          option: option,
          index: index,
          hasBeenVoted: hasBeenVoted || state === VOTE_MODULE_STATE_CLOSED,
          isVotedFor: optionsId === votedOptionId,
          onPress: onPressOption ? function () {
            if (typeof trackBwin === 'function') {
              trackBwin({
                type: 'BET_FANVOTING_VOTING',
                competition: competition,
                fanvotingType: type
              });
            }

            _this2.voteForOption(id, optionsId, index);
          } : undefined,
          cardShadow: !hasBeenVoted ? cardShadow : {},
          useFontelloIcons: useFontelloIcons,
          highlightColor: highlightColor,
          minWidth: minWidth,
          iconSize: iconSize,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 134,
            columnNumber: 29
          }
        });
      })), hasBeenVoted && state === VOTE_MODULE_STATE_OPEN && _react.default.createElement(_TipModule.default, {
        providerLogo: providerLogo,
        bettingLinkText: bettingOption ? betting.bettingLinkText : betting.fallbackText,
        betting: bettingOption,
        fallbackLink: betting.fallbackLink,
        onPress: function onPress(link) {
          if (typeof onOutboundLinkClick === 'function') {
            onOutboundLinkClick({
              link: link
            });
          }

          if (typeof trackBwin === 'function') {
            trackBwin({
              type: 'BET_FANVOTING_AD_CLICK',
              competition: competition,
              fanvotingType: type,
              link: link
            });
          }
        },
        buttonStyles: buttonStyles,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 165,
          columnNumber: 21
        }
      }), _react.default.createElement(_Basic.Row, {
        evenly: true,
        mx: 3,
        mt: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 188,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Text, {
        size: "small",
        mr: 1,
        color: "gray",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 189,
          columnNumber: 21
        }
      }, "-w-"), _react.default.createElement(_Basic.View, (0, _extends2.default)({
        p: 2,
        bg: "white"
      }, logoContainerStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 192,
          columnNumber: 21
        }
      }), _react.default.createElement(_Logos.AssetLogo, {
        width: logoWidth || 47,
        height: logoHeight || 16,
        ml: 1,
        src: providerLogo,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 193,
          columnNumber: 25
        }
      }))));
    }
  }]);
  return VoteModule;
}(_react.default.Component);

VoteModule.propTypes = {
  id: _propTypes.default.string,
  type: _propTypes.default.string,
  competition: _propTypes.default.object,
  voting: _propTypes.default.object,
  providerLogo: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  providerLogoStyles: _propTypes.default.object,
  buttonStyles: _propTypes.default.object,
  cardShadow: _propTypes.default.object,
  userChoice: _propTypes.default.number,
  trackBwin: _propTypes.default.func,
  onOutboundLinkClick: _propTypes.default.func,
  onPressOption: _propTypes.default.func,
  pageId: _propTypes.default.string,
  useFontelloIcons: _propTypes.default.bool,
  highlightColor: _propTypes.default.string
};
VoteModule.defaultProps = {
  voting: {}
};
var _default = VoteModule;
exports.default = _default;